import type { JSX } from 'react';
import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type { ServiceOrganizationRole as Role } from '@common/enums';
import type { IServiceOrganizationSettingRoleDistribution } from '@frontend/components/interfaces/serviceOrganizationSettingRoleDistribution';
import { concatOrNull } from '@common/utils/textUtils';
import { getSelectedLanguage } from '@frontend/translate';

interface IServiceOrganizationRoleDistributionsReadProps {
    roles: Role[];
    serviceOrganizationRoleDistributions: IServiceOrganizationSettingRoleDistribution[];
}

export function ServiceOrganizationRoleDistributionsRead(
    props: IServiceOrganizationRoleDistributionsReadProps
): JSX.Element {
    return (
        <>
            {props.roles.map((role) => (
                <FormSection
                    key={role}
                    title={`${getSelectedLanguage().serviceOrganizationSettingRoleDistributions.partnerOrganizations} ${
                        getSelectedLanguage().serviceOrganizationRoleEnum[role]
                    }`}
                >
                    {getDistributionRolesByRole(role).map((distributionRole) => (
                        <FormGroup
                            key={distributionRole.serviceOrganizationRole.serviceOrganizationSetting.organization.id}
                            label={
                                distributionRole.serviceOrganizationRole.serviceOrganizationSetting.organization.name
                            }
                        >
                            <FormParagraph>
                                {concatOrNull(Math.round(distributionRole.percentage * 100) / 100, '%')}
                            </FormParagraph>
                        </FormGroup>
                    ))}
                </FormSection>
            ))}
        </>
    );

    function getDistributionRolesByRole(role: Role): IServiceOrganizationSettingRoleDistribution[] {
        return props.serviceOrganizationRoleDistributions.filter(
            (serviceOrganizationDistributionRole) => serviceOrganizationDistributionRole.role === role
        );
    }
}
